/* Product-card photo swipe (6 Oct 2026). Loads a card's extra photos on the first sideways
   scroll of its strip (not on touch, so scrolling down the page loads nothing) and moves the
   position bar. Event delegation, so cards added later (Load more, tabs, filters) work too. */
(() => {
  const hydrate = (strip) => {
    if (strip.dataset.ycLoaded) return;
    strip.dataset.ycLoaded = '1';
    strip.querySelectorAll('img[data-srcset]').forEach((img) => {
      img.sizes = img.dataset.sizes;
      img.srcset = img.dataset.srcset;
      img.removeAttribute('data-srcset');
    });
  };
  document.addEventListener('scroll', (e) => {
    const strip = e.target;
    if (!(strip instanceof Element) || !strip.classList.contains('yc-swipe')) return;
    hydrate(strip);
    const i = Math.round(Math.abs(strip.scrollLeft) / (strip.clientWidth || 1));
    const bar = strip.nextElementSibling;
    if (bar && bar.classList.contains('yc-swipe__bar')) bar.style.setProperty('--yc-i', i);
  }, { capture: true, passive: true });
})();
